<template lang="html">
  <div class="illustrator-clients set-after">
    <div class="col-eight col-offset-2">
      <label class="col-twelve">New client</label>
      <div class="col-nine">
        <input type="text" v-model="newClient" class="long-input">
      </div>
      <div class="col-three align-center">
        <button class="bit-purple-button" @click="addClient">Add</button>
      </div>
    </div>
    <illustrator-client v-for="client in clients" :client="client" :key="client.id"
                        @clientDeleted="deleteClient"></illustrator-client>
  </div>
</template>

<script>
export default {
  props: ['default'],
  data() {
    return {
      clients: [],
      newClient: '',
      previousClient: ''
    };
  },
  methods: {
    deleteClient(deletedClient) {
      this.clients = this.clients.filter((client) => {
        return client.id !== deletedClient.id;
      });
    },
    addClient() {
      if (this.newClient.trim() == '') {
        alert('New client field can not be null');
        return;
      }
      if (this.newClient !== this.previousClient) {
        axios.post('/profile/ajax/add/client', {
          name: this.newClient
        }).then((response) => {
          this.clients.push({
            id: response.data.id,
            name: this.newClient
          });
          this.previousClient = this.newClient;
          this.newClient = '';
        });
      }
    }
  },
  created() {
    if (this.default) {
      let clients = [];
      for (let key in this.default) {
        clients.push(this.default[key]);
      }
      clients.sort(function (a, b) {
        if (a['weight'] > b['weight']) {
          return 1;
        } else if (a['weight'] < b['weight']) {
          return -1;
        }
        return 0;
      });
      this.clients = clients;
    }
  }
};
</script>

<style lang="scss">
  .illustrator-clients {
    margin-top: 15px;
  }
</style>